export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";
export const ENV_NAME = process.env.REACT_APP_ENV_NAME || "test";
export const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || "";
export const IV_LENGTH = 16;
export const DISDETTA_MIN_DAYS = 60;
export const PER_PAGE_MAX_LIMIT = 20000;
export const RECAPTCHA_SITE_KEY = "6LdcTJMUAAAAALS7n9jHEAMBn17vcXLRgWp6GWFh";
export const MYSECRET_KEY = process.env.REACT_APP_MYSECRET_KEY || "";
export const STATE = process.env.REACT_APP_STATE || "";
export const AUTHORIZE_CHECK = {
    // test è come staging ma mi serve per quando tcc gira in locale e ENV_NAME prende di default test
    test: {
        url:
            process.env.REACT_APP_IDENTITY_TOKEN_URL ||
            "https://identity-stage.teamsystem.com/connect/authorize",
        client_id:
            process.env.REACT_APP_IDENTITY_CLIENT_ID ||
            "e99e96ed-2734-425b-90c2-2015048c733d"
    },
    staging: {
        url: process.env.REACT_APP_IDENTITY_TOKEN_URL,
        client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID
    },
    production: {
        url: process.env.REACT_APP_IDENTITY_TOKEN_URL,
        client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID
    }
};

export const LOGIN_TSID = process.env.REACT_APP_LOGIN_TSID || "true";



// WEBPACK FOOTER //
// ./src/config.js